import * as React from 'react';

function SvgCrossInCircle(props) {
  return (
    <svg
      width="1em"
      height="1em"
      viewBox="0 0 30 30"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      {...props}
    >
      <path
        d="M14.306 15l-3.45-3.534a.437.437 0 010-.607.412.412 0 01.592 0l3.524 3.609a.389.389 0 01.057 0l3.523-3.609a.412.412 0 01.592 0 .437.437 0 010 .607L15.694 15l3.45 3.534a.437.437 0 010 .607.412.412 0 01-.592 0l-3.523-3.609a.389.389 0 01-.057 0l-3.524 3.609a.412.412 0 01-.592 0 .437.437 0 010-.607L14.306 15z"
        fill="#414B56"
      />
      <circle cx={15} cy={15} r={10.5} stroke="#414B56" />
    </svg>
  );
}

export default SvgCrossInCircle;
